import React, { useState } from 'react';
import { HiMenuAlt4, HiX } from 'react-icons/hi';
import { motion } from 'framer-motion';
import { images } from '../../constants';
import './Navbar.scss';

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const links = [
    {
      'name': 'home',
      'url': '#home',
      'target': '_self',
    },
    {
      'name': 'work',
      'url': '#work',
      'target': '_self',
    },
    {
      'name': 'about',
      'url': '#about',
      'target': '_self',
    },
    {
      'name': 'skills',
      'url': '#skills',
      'target': '_self',
    },
    {
      'name': 'contact',
      'url': '#contact',
      'target': '_self',
    },
    {
      'name': 'blog',
      'url': 'https://omesh-blog.vercel.app/',
      'target': '_blank',
    },
  ];
  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo">
        <div>
          <img src={images.logo} alt="" className="logo" />
        </div>
      </div>
      <ul className="app__navbar-links">
        {links.map((item) => (
          <li className="app__flex p-text" key={`link-${item.name}`}>
            <div />
            <a href={item.url} target={item.target}>
              {' '}
              {item.name}{' '}
            </a>
          </li>
        ))}
      </ul>
      <div className="app__navbar-menu">
        <HiMenuAlt4
          className="cursor-pointer"
          onClick={() => setToggle(true)}
        />

        <motion.div
          // whileInView={{ x: [300, 0] }}
          transition={{ duration: 0.85, ease: 'easeOut' }}
          className={toggle ? 'toggle show-toggle' : 'toggle'}
        >
          <div className="">
            <HiX
              className="cursor-pointer mt-2"
              onClick={() => setToggle(false)}
            />
          </div>
          <ul>
            {links.map((item) => (
              <li key={item}>
                <a href={item.url} onClick={() => setToggle(false)}>
                  {item.name}
                </a>
              </li>
            ))}
          </ul>
        </motion.div>
      </div>
    </nav>
  );
};

export default Navbar;
